export default "/images/5c490d94af43d9460392236e9aae32b1.avif";